import { storageProvider } from '@ocean/configs'
import { CustomerDateTimeFormat, Permissions } from 'core/environment/types'
import { Configuration } from 'core/environment/types'

export const ENVIRONMENT_CONFIGURATION = 'ENVIRONMENT_CONFIGURATION'

class EnvironmentUtils {
  storeEnvironmentConfiguration(configuration?: Configuration) {
    if (!configuration) return
    storageProvider.setItem(ENVIRONMENT_CONFIGURATION, JSON.stringify(configuration))
  }

  getEnvironmentConfiguration(): Configuration | null {
    const configuration = storageProvider.getItem(ENVIRONMENT_CONFIGURATION)
    if (!configuration) return null
    return JSON.parse(configuration)
  }

  getDateTimeFormat(): CustomerDateTimeFormat | undefined {
    const configuration = this.getEnvironmentConfiguration()
    return configuration?.customerDateTimeFormat
  }

  getPermissions<K extends keyof Permissions>(key: K): Permissions[K] {
    const configuration = this.getEnvironmentConfiguration()
    return (configuration?.permissions[key] || {}) as Permissions[K]
  }

  clearEnvironmentConfiguration() {
    storageProvider.removeItem(ENVIRONMENT_CONFIGURATION)
  }
}

export default new EnvironmentUtils()
